<template>
  <simple-table
    :items="items"
    :title-table="'Últimas Alertas'"
    :loading.sync="loading"
    :per-page="3"
  />
</template>

<script>
import store from '@/store'
import SimpleTable from '@/views/utils/SimpleTable.vue'
import moment from 'moment-timezone'
import alertHistoryStoreModule from './alertHistoryStoreModule'
import allFetchData from './allFetchData'

export default {
  components: {
    SimpleTable,
  },
  setup() {
    const ALERT_HISTORY_APP_STORE_MODULE_NAME = 'alertHistory'

    // Register module
    if (!store.hasModule(ALERT_HISTORY_APP_STORE_MODULE_NAME)) store.registerModule(ALERT_HISTORY_APP_STORE_MODULE_NAME, alertHistoryStoreModule)

    const {
      fetchAlertsByDevice,
      refDataTable,
      loading,
    } = allFetchData()

    return {
      fetchAlertsByDevice,
      refDataTable,
      loading,
    }
  },
  props: {
    deviceId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      items: [],
      deviceDataKey: '',
    }
  },
  mounted() {
    this.deviceDataKey = this.$route.params.data
    this.fetchAlertsByDevice({ deviceId: this.deviceId, dataKey: this.deviceDataKey }, res => {
      // set new data from res with new columns
      this.items = res.map(item => {
        let valorFormatted = item.valueAlert
        if (moment(item.valueAlert, moment.ISO_8601, true).isValid()) {
          valorFormatted = moment.utc(item.valueAlert).local().format('DD/MM/YYYY hh:mm:ss a')
        }
        return {
          Alerta: item.name,
          Valor: valorFormatted,
          Fecha: moment.utc(item.updatedAt).local().format('DD/MM/YYYY hh:mm:ss a'),
        }
      })
    })
  },
}
</script>
